class WebSocketManager {
  constructor() {
    this.sockets = {}; // Azonosítóhoz tartozó WebSocket példányok
    this.messages = []; // WebSocket üzenetek
    this.reconnectInterval = 1000; // 1 másodperc reconnect
  }

  connect(id, url, config = {}) {
    const createSocket = () => {
      if (this.sockets[id]) {
        console.warn(`Már létezik kapcsolat ezzel az ID-vel: ${id}`);
        return this.sockets[id];
      }

      const socket = new WebSocket(url);

      socket.onopen = () => {
        socket.send(JSON.stringify({ type: 'register', clientId: id }));
        if (config.onOpen) config.onOpen();
      };

      socket.onclose = (event) => {

        if (config.onClose) config.onClose(event);

        // Ha 1005 vagy bármilyen ismeretlen close, feltételezhetjük token lejárt
        if (event.code === 1005) {
          //alert("A munkamenet lejárt, kérlek jelentkezz be újra!");
          window.location.href = "/login"; // vagy login modal megjelenítése
          return; // nem reconnect-elünk
        }

        // Egyéb esetben reconnect
        setTimeout(() => {
          delete this.sockets[id];
          createSocket();
        }, this.reconnectInterval);
      };

      socket.onmessage = (message) => {
        if (config.onMessage) config.onMessage(message);
        this.messages.push(message.data);
      };

      socket.onerror = (err) => {
        console.error(`WebSocket error (${id}):`, err);
        socket.close();
      };

      this.sockets[id] = socket;
      return socket;
    };

    return createSocket();
  }

  disconnect(id) {
    if (this.sockets[id]) {
      this.sockets[id].close();
      delete this.sockets[id];
    }
  }

  sendMessage(id, message) {
    const ws = this.sockets[id];
    if (ws && ws.readyState === WebSocket.OPEN) {
      ws.send(message);
    } else {
      console.error(`Nincs aktív kapcsolat ezzel az ID-vel: ${id}`);
    }
  }

  disconnectAll() {
    Object.keys(this.sockets).forEach(id => this.disconnect(id));
  }

  getMessages() {
    return this.messages;
  }
}

export default WebSocketManager;
